import ajaxService from '../services/ajaxService';
import {renderFirstReCaptcha} from './reCaptchaHelpers';

class MissingInfoBlock {
	/** @type {HTMLDivElement} */
	#modal;
	/** @type {HTMLFormElement} */
	#form;
	/** @type {HTMLButtonElement} */
	#submitBtn;
	/** @type {{pageType: string}} */
	#params;
	
	/**
	 * @param {{pageType: string}} params
	 */
	constructor(params) {
		this.#params = params;
		this.#modal = document.getElementById('missingInfoModal');
		this.#form = this.#modal.querySelector('form');
		this.#submitBtn = this.#modal.querySelector('.send-missing-info-request');
		
		this.#init();
	}
	
	#init() {
		this.#modal.addEventListener('show.bs.modal', () => {
			renderFirstReCaptcha({
				'renderParams': {
					'element': document.getElementById('missingInfoFormRecaptcha')
				}
			});
			this.#initEvents();
		});
	}
	
	#initEvents() {
		const missingInfoMessageElement = document.getElementById('missingInfoMessage');
		
		missingInfoMessageElement.addEventListener(
			'change',
			() => {
				missingInfoMessageElement.parentElement.classList.add('was-validated');
			},
			{
				'once': true
			}
		);
		
		this.#form.addEventListener(
			'submit',
			(ev) => {
				ev.preventDefault();
				this.#submitForm()
					.catch(console.error);
			}
		);
	}
	
	/**
	 * @returns {Promise}
	 */
	async #submitForm() {
		if (!this.#isValidForm()) {
			return;
		}
		
		this.#lockForm();
		
		const completeFormData = Object.fromEntries(new FormData(this.#form)),
		      {
			      'g-recaptcha-response': reCaptchaToken,
			      ...formData
		      } = completeFormData,
		      result = await ajaxService.sendPost({
			      'url' : 'missing-info/send',
			      'data': {
				      formData,
				      reCaptchaToken,
				      ...this.#params
			      }
		      });
		
		this.#handleResponse(result);
	}
	
	#handleResponse({response, xhr}) {
		const responseObject  = typeof xhr === 'object' ? xhr : response,
		      newModalClasses = ['after-response'];
		
		responseObject
			.then(() => {
				newModalClasses.push('after-successful-response');
			})
			.catch(() => {
				newModalClasses.push('after-error-response');
			})
			.always(() => {
				this.#modal.classList.add(...newModalClasses);
			});
	}
	
	/**
	 * @returns {boolean}
	 */
	#isValidForm() {
		return this.#form.checkValidity() && window.grecaptcha?.getResponse?.();
	}
	
	#lockForm() {
		this.#submitBtn.classList.add('disabled');
		this.#submitBtn.disabled = true;
	}
	
}

export default MissingInfoBlock;